import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_USER } from '../../data.const';
import {
  setCurrentUserAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveUserEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_USER),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_USER}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ userLoader: true })),
        defer(() =>
          from(request({ path: `user/${id}`, method: httpMethods.GET })).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_USER}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentUserAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_USER}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ userLoader: false }))
      );
    })
  );

export default retrieveUserEpic;
